import { Button, Modal } from "antd";
import React from "react";
import Cancel from "../../assets/ImageAddControl/cancel.svg";

type Props = {
  onCancel: () => void;
  visible: boolean;
};
const IndividualBlackListModal: React.FC<Props> = ({ onCancel, visible }) => {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      closable={false}
      maskClosable={false}
      centered
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "20px",
          minHeight: "300px",
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            fontSize: "2.5rem",
            textAlign: "center",
            width: "80%",
          }}
        >
          <>
            <img
              src={Cancel}
              alt="Cancel"
              style={{ width: "200px", height: "200px" }}
            />
            <div>
              ปฎิเสธลงทะเบียนผู้ค้ากับสภากาชาดไทย เนื่องจากข้อมูลติด Blacklist"
            </div>
          </>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(1,1fr)",
              gap: "1rem",
              marginTop: "4rem",
            }}
          >
            <Button
              style={{
                backgroundColor: "#C95559",
                color: "#F0F0F0",
                borderRadius: "8px",
                height: "60px",
                fontSize: "2rem",
                fontWeight: "bold",
              }}
              onClick={onCancel}
            >
              ยืนยัน
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default IndividualBlackListModal;
